import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import moment from "moment";
import BounceLoader from "react-spinners/BounceLoader";
import LoadingOverlay from "../../common/Loader";
import Toaster from "../../components/Toaster";

import Header from "../../common/header";
import Footer from "../../common/footer";
import Sidebar from "../../common/sidebar";

import DateRangePicker from "react-bootstrap-daterangepicker";
import "bootstrap-daterangepicker/daterangepicker.css";

import { api } from "../../Services/index";
import { axiosClient, config } from "./../../Services/Config";
// var apiConfig = require('../../Services/constant.json')[process.env.REACT_APP_ENV || 'dev'];

//html editor
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { EditorState, convertToRaw, ContentState } from "draft-js";
import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";
import { any } from "prop-types";
import SweetAlert from "react-bootstrap-sweetalert";
import IdleTimer from "../../common/IdleTimer";

const loaderStyle = {
  color: "#f3f3f3",
};

class Faq extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      tab: 6,
      faqData: [],
      spinnerColor: "#000000",
      spinnerLoading: false,
      userLoggedIn: false,
      loginname: null,
      userloginid: null,
      editorState: EditorState.createEmpty(),
      faq_id: 0,
      mode: "add",
      current_question: null,

      showPublishAlert: false,
      toasterMessage: "",
      indViewFaqData: null,
    };
    // this.state = {
    //     editorState: EditorState.createEmpty(),
    //   };
    this.saveFAQ = this.saveFAQ.bind(this);
  }

  onEditorStateChange = (editorState) => {
    this.setState({
      editorState,
    });
  };

  componentDidMount() {
    this.setState(
      {
        faq_id: this.props.history.location.state.faq_id,
        mode: this.props.history.location.state.mode,
      },
      () => {
        //console.log('set loc faq_id');
      },
    );

    this.setUserInfo();
  }

  tabchangeevent = (e) => {
    this.setState({ tab: e });
  };

  onQuestionChange = (event) => {
    let tmpQuestionText = event.target.value;
    this.setState(
      {
        current_question: tmpQuestionText,
      },
      () => {
        // console.log('set qn change');
      },
    );

    // tmpdcgForm[0].sections[sectionIndex].questions = tmpquestions;

    // this.setState(prevState => ({
    //     dcgForm: [...tmpdcgForm]
    // }))
  };

  setUserInfo = () => {
    var userinfo = JSON.parse(localStorage.getItem("userinfo"));
    if (userinfo) {
      this.setState(
        {
          loginname: userinfo.roleinfo.loginname,
          userloginid: userinfo.roleinfo.userloginid,
          userLoggedIn: true,
        },
        () => {
          // console.log('mode ' + this.state.mode);
          // console.log('faq_id ' + this.state.faq_id);
          // this.getFaqData(this.state.loginname);
          this.getIndividualFaqData(this.state.faq_id);
        },
      );
    } else {
      this.props.history.push("/login");
      // return;
    }
  };

  getFaqData(userId) {
    try {
      this.setState({ spinnerLoading: true });
      api
        .getFaqData(userId)
        .then((data) => {
          this.setState(
            {
              faqData: data.data.faqs,
              spinnerLoading: false,
            },
            () => {
              //console.log('set');
              this.loadDataToEditor();
            },
          );
          // console.log(data.data.faqs[0]);
        })
        .catch((error) => {
          console.log("faq data load Error : " + error);
        });
    } catch (e) {}
  }

  getIndividualFaqData(faqId) {
    try {
      this.setState({ spinnerLoading: true });
      api
        .getIndFaqData(faqId)
        .then((data) => {
          this.setState(
            {
              indViewFaqData: data.data,
              spinnerLoading: false,
            },
            () => {
              this.loadDataToEditor();
            },
          );
        })
        .catch((error) => {
          console.log("faq data load Error : " + error);
        });
    } catch (e) {}
  }

  loadDataToEditor = () => {
    // console.log('this.state.faq_id ' + this.state.faq_id);
    // const html = '<p>Hey this <strong>editor</strong> rocks 😀</p>';

    var html = "";
    var question_text = "";

    if (this.state.mode === "edit") {
      // html = this.state.faqData[this.state.faq_id-1].answer_text;
      // question_text = this.state.faqData[this.state.faq_id-1].question_text;
      // this.getIndividualFaqData();

      html = this.state.indViewFaqData.answer_text;
      question_text = this.state.indViewFaqData.question_text;
    } else {
      html = "";
      question_text = "";
    }

    // const html = this.state.faqData[0].answer_text;
    const contentBlock = htmlToDraft(html);
    if (contentBlock) {
      const contentState = ContentState.createFromBlockArray(
        contentBlock.contentBlocks,
      );
      const editorState = EditorState.createWithContent(contentState);
      this.state = {
        editorState,
      };

      this.setState(
        {
          editorState,
          current_question: question_text,
        },
        () => {},
      );
    }
  };

  publishFaq = () => {
    this.setState({
      showPublishAlert: true,
    });
  };

  onCancelPublishAlert = () => {
    this.setState({
      showPublishAlert: false,
    });
  };

  publishFaqConfirm = () => {
    try {
      try {
        var arrFaqs = [];

        if (this.state.mode === "edit") {
          var ind_faqs = {
            faq_id: this.state.faq_id,
            question_text: this.state.current_question,
            answer_text: draftToHtml(
              convertToRaw(this.state.editorState.getCurrentContent()),
            ),
            is_update: true,
            is_delete: false,
          };
        } else {
          var ind_faqs = {
            faq_id: this.state.faq_id,
            question_text: this.state.current_question,
            answer_text: draftToHtml(
              convertToRaw(this.state.editorState.getCurrentContent()),
            ),
            is_update: false,
            is_delete: false,
          };
        }

        arrFaqs.push(ind_faqs);

        var publishObj = { salesrepname: this.state.loginname, faqs: arrFaqs };

        api
          .publishFAQ(publishObj)
          .then((data) => {
            if (data && data.response && data.response.status == 401) {
                  localStorage.removeItem("userinfo");
this.props.history.push("/login");
            } else {
              this.setState({
                showPublishAlert: false,
              });
              this.toggleToaster("Updated Successsfully", "success");
            }
          })
          .catch((error) => {
            this.setState({
              showPublishAlert: false,
            });
            console.log("Error : " + error);
            this.toggleToaster(
              "Failed to retrieve data from the API. Please try again later.",
              "error",
            );
          });
      } catch (e) {}
    } catch (e) {}
  };
  getrefreshtoken(actionPayload) {
    getRefreshToken()
      .then((res) => {
        api
          .getStoreComparisonDataPost(actionPayload)
          .then((data) => {
            this.setState({
              comparisonData: data.data.data,
              spinnerLoading: false,
            });
            this.getMarketData();
          })
          .catch((error) => {
            console.log("Error : " + error);
          });
      })
      .catch((err) => {
         localStorage.removeItem("userinfo");
this.props.history.push("/login");
      });
  }
  toggleToaster(message, type) {
    this.setState({
      toasterMessage: message,
      toasterType: type,
    });

    setTimeout(() => {
      this.setState({
        toasterMessage: null,
        toasterType: undefined,
      });
    }, 1000);
  }

  saveFAQ = () => {
    // console.log('editorState');
    // console.log(this.state.editorState.getCurrentContent());
    // console.log(draftToHtml(convertToRaw(this.state.editorState.getCurrentContent())));

    this.publishFAQConfirmOLD();
  };

  onCancel = () => {
    this.props.history.push({
      pathname: "/faq-list",
    });
  };

  publishFAQConfirmOLD = () => {
    try {
      var arrFaqs = [];
      // var ind_faqs = {
      //     "question_text": this.state.current_question,
      //     "answer_text": draftToHtml(convertToRaw(this.state.editorState.getCurrentContent())),
      //     "is_update": false,
      //     "is_delete": false
      // };

      if (this.state.mode === "edit") {
        var ind_faqs = {
          question_text: this.state.current_question,
          answer_text: draftToHtml(
            convertToRaw(this.state.editorState.getCurrentContent()),
          ),
          is_update: true,
          is_delete: false,
        };
      } else {
        var ind_faqs = {
          question_text: this.state.current_question,
          answer_text: draftToHtml(
            convertToRaw(this.state.editorState.getCurrentContent()),
          ),
          is_update: false,
          is_delete: false,
        };
      }

      arrFaqs.push(ind_faqs);

      var publishObj = { salesrepname: this.state.loginname, faqs: arrFaqs };
      api
        .publishFAQ(publishObj)
        .then((data) => {
          // // console.log('after publishing data result data');
          // // console.log(data);
          // this.setState({ showPublishAlert: false })
          // this.toggleToaster("Updated Successsfully", "success");
          // setTimeout(this.getDCGQUestionTemplate(), 2000);
        })
        .catch((error) => {
          console.log("Error : " + error);
        });
    } catch (e) {}
  };

  render() {
    const { editorState } = this.state;
    return (
      <div className="wrapper">
        <LoadingOverlay
          active={this.state.spinnerLoading}
          spinner={<BounceLoader />}
          className={loaderStyle}
        >
          <Header />
          <Sidebar tab={this.state.tab} tabchangeevent={this.tabchangeevent} />
          <IdleTimer></IdleTimer>
          <div className="content-wrapper pb-4">
            {this.state.toasterMessage ? (
              <Toaster
                message={this.state.toasterMessage}
                toasterType={this.state.toasterType}
              />
            ) : null}
            <section class="content">
              <div class="container-fluid">
                <div class="row">
                  <div class="col-md-12">
                    <h5>FAQ</h5>
                    <hr />
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-5"></div>
                  <div class="col-md-5"></div>
                  <div class="col-md-2 text-right">
                    <div class="form-group mt-1 pt-4">
                      <a
                        href="#"
                        onClick={this.onCancel}
                        class="btn btn-primary"
                      >
                        Cancel
                      </a>
                      &nbsp;&nbsp;
                      <a
                        href="#"
                        onClick={this.publishFaq}
                        class="btn btn-primary"
                      >
                        Save
                      </a>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-12">
                    <div class="form-group">
                      <label>Question</label>
                      <div class="input-group">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Question"
                          value={this.state.current_question}
                          onChange={(e) => this.onQuestionChange(e)}
                          data-id={this.state.faq_id}
                          id={"e" + this.state.current_question}
                          name={"e" + this.state.current_question}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <label>Answer</label>
                    <Editor
                      editorState={editorState}
                      toolbarClassName="toolbarClassName"
                      wrapperClassName="wrapperClassName"
                      editorClassName="editorClassName"
                      onEditorStateChange={this.onEditorStateChange}
                      toolbar={{
                        options: [
                          "inline",
                          "fontSize",
                          "textAlign",
                          "blockType",
                          "list",
                        ],
                      }}

                      // toolbar={{
                      //     inline: { inDropdown: true },
                      //     list: { inDropdown: true },
                      //     textAlign: { inDropdown: true },
                      //     link: { inDropdown: true },
                      //     history: { inDropdown: true },
                      //   }}
                    />
                  </div>
                </div>
              </div>
            </section>

            {this.state.showPublishAlert && (
              <SweetAlert
                showCancel
                confirmBtnText="Yes, publish!"
                style={{ color: "#000000", fontSize: "11px", minWidth: "30%" }}
                title="Are you sure to publish?"
                onConfirm={this.publishFaqConfirm}
                onCancel={this.onCancelPublishAlert}
                focusCancelBtn={true}
                closeOnClickOutside={true}
                allowEscape={true}
                btnSize={"sm"}
              >
                <span style={{ color: "#000000", fontSize: "12px" }}>
                  Your FAQ changes will be updated!
                </span>
              </SweetAlert>
            )}
          </div>
        </LoadingOverlay>

        <Footer />
        <aside className="control-sidebar control-sidebar-dark"></aside>
      </div>
    );
  }
}
export default withRouter(Faq);
